(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26920],{

/***/ 928677:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop",
      function () {
        return __webpack_require__(238758);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 665207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ HeadSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




const HeadSection = (param)=>{
    let { title , metaTitle , description , keywords , image , canonical , prevHref , nextHref , noindex =false , links  } = param;
    const { meta  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle || title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: metaTitle || title || meta.title
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description || meta.description
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description || meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image || meta.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image || meta.image
            }),
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            prevHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevHref
            }),
            nextHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextHref
            }),
            links === null || links === void 0 ? void 0 : links.map((attrs)=>Object.keys(attrs).length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, attrs))),
            meta.dcmaVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "dmca-site-verification",
                content: meta.dcmaVerificationContent
            }),
            meta.fbDomainVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: meta.fbDomainVerificationContent
            })
        ]
    });
};


/***/ }),

/***/ 770353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "w": function() { return /* binding */ useIdentifiedPage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);

const useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
const useIdentifiedPage = (className)=>{
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const node = document.createElement("div");
        node.className = className;
        node.style.display = "none";
        document.body.prepend(node);
        return ()=>node.remove();
    }, []);
};


/***/ }),

/***/ 238758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ default_desktop; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./components/HeadSection.tsx
var HeadSection = __webpack_require__(665207);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./hooks/common.ts
var common = __webpack_require__(770353);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./modules/home/desktop/Home.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






const DefaultHome = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(19303), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(4545), __webpack_require__.e(18299), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(57663), __webpack_require__.e(29412), __webpack_require__.e(47991)]).then(__webpack_require__.bind(__webpack_require__, 847991)).then((mod)=>mod.DefaultHome), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(847991)
            ]
    }
});
const PbHome = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(93712), __webpack_require__.e(1393), __webpack_require__.e(96464), __webpack_require__.e(25700), __webpack_require__.e(75803), __webpack_require__.e(33249), __webpack_require__.e(12512), __webpack_require__.e(4857), __webpack_require__.e(50424), __webpack_require__.e(46921), __webpack_require__.e(88568), __webpack_require__.e(12583), __webpack_require__.e(59063), __webpack_require__.e(97736), __webpack_require__.e(70818), __webpack_require__.e(72992), __webpack_require__.e(71991), __webpack_require__.e(81826), __webpack_require__.e(97115), __webpack_require__.e(60342), __webpack_require__.e(48019), __webpack_require__.e(63932), __webpack_require__.e(19303), __webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(54615), __webpack_require__.e(76414), __webpack_require__.e(92952), __webpack_require__.e(146), __webpack_require__.e(65997), __webpack_require__.e(80300), __webpack_require__.e(48797), __webpack_require__.e(71565), __webpack_require__.e(45590), __webpack_require__.e(88837), __webpack_require__.e(49354), __webpack_require__.e(52615), __webpack_require__.e(19451)]).then(__webpack_require__.bind(__webpack_require__, 170919)).then((mod)=>mod.PbPage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(170919)
            ]
    }
});
const Home = (_param)=>{
    var { menuItems , pbContent , pbMetaData , pbSSRData , menu  } = _param, defaultHomeProps = _objectWithoutProperties(_param, [
        "menuItems",
        "pbContent",
        "pbMetaData",
        "pbSSRData",
        "menu"
    ]);
    var ref;
    const { epicPb1887 , baseDomain , canonicalDomain  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    (0,common/* useIdentifiedPage */.w)("homePage");
    (0,react.useEffect)(()=>{
        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadSection/* HeadSection */.I, _objectSpread({
                canonical: canonicalDomain || baseDomain
            }, epicPb1887 && pbMetaData ? {
                title: pbMetaData.metaTitle,
                description: pbMetaData.metaDescription,
                keywords: (ref = pbMetaData.metaKeywords) === null || ref === void 0 ? void 0 : ref.toString()
            } : {})),
            epicPb1887 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PbHome, {
                pbContent: pbContent,
                pbSSRData: pbSSRData,
                pbMetaData: pbMetaData,
                menu: menu
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultHome, _objectSpread({
                menuItems: menuItems
            }, defaultHomeProps))
        ]
    });
};

;// CONCATENATED MODULE: ./tenants/_template/desktop/index.tsx
function desktop_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function desktop_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            desktop_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




const HomePage = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, desktop_objectSpread({}, props));
};
const getServerSideProps = (/* unused pure expression or super */ null && (getServerSidePropsHome));
/* harmony default export */ var desktop = (HomePage);

;// CONCATENATED MODULE: ./pages/default/desktop/index.tsx
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ var default_desktop = (desktop);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [93712,49774,92888,40179], function() { return __webpack_exec__(928677); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);